import React from "react"

export default function TestimonialCard(props) {
    return (
        <>
        <div className={props.one ? "testimonialCard testimonialCard2" : "testimonialCard testimonialCard1"} data-aos="fade-up" data-aos-once="true" data-aos-delay="500">
            <div className="testimonialCardInfoOne">
                <div className="testimonialCardImage"></div>
                <div className="testimonialCardInfoInfo">
                    <p>{props.header}</p>
                    <div className="testimonialCardRating">
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="testimonialCardStar">
                            <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#FF3737"/>
                        </svg>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="testimonialCardStar">
                            <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#FF3737"/>
                        </svg>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="testimonialCardStar">
                            <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#FF3737"/>
                        </svg>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="testimonialCardStar">
                            <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#FF3737"/>
                        </svg>
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="testimonialCardStar">
                            <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#FF3737"/>
                        </svg>
                    </div>
                </div>
            </div>
            <p className="testimonialCardDescription">{props.description}</p>
        </div>
        </>
    )
}